import { makeStyles } from "@material-ui/core"

export const DashboardOverviewStyles = makeStyles(() => ({
  grid2: {
    backgroundColor: "rebeccapurple",
    marginTop: "-3.5rem",
    paddingTop: "3.45rem !important",
    color: "white",
  }
}))
